export default "__VITE_ASSET__ChopMpH0__";